import { g as s } from "./get-built-in.js";
import { d as r } from "./define-built-in-accessor.js";
import { w as i } from "./well-known-symbol.js";
import { d as o } from "./descriptors.js";
var e = i("species"),
  t = function t(i) {
    var t = s(i);
    o && t && !t[e] && r(t, e, {
      configurable: !0,
      get: function get() {
        return this;
      }
    });
  };
export { t as s };